import { selectDOMRect } from 'app/pages/App/slice/selectors';
import { selectLengthCart } from 'app/pages/Cart/slice/selectors';
import { RefObject, useCallback } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  elementRef: RefObject<HTMLElement>;
}

const useScrollIntoElement = (props: Props) => {
  const { elementRef } = props;
  const DOMRect = useSelector(selectDOMRect);
  const cartLength = useSelector(selectLengthCart);
  const headerDOMRect = DOMRect?.header;

  const onScrollIntoElement = useCallback(() => {
    if (elementRef.current) {
      window.scroll(
        0,
        elementRef.current.getBoundingClientRect().top +
          window.scrollY -
          (headerDOMRect?.height ?? 0) -
          (cartLength > 0 ? 20 : 0),
      );
    }
  }, [cartLength, elementRef, headerDOMRect?.height]);

  return {
    onScrollIntoElement,
  };
};

export default useScrollIntoElement;
